var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetAppIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "direct-inbox"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 4.12891C3.46 4.64891 2 6.72891 2 10.9989V14.9989C2 19.9989 4 21.9989 9 21.9989H15C20 21.9989 22 19.9989 22 14.9989V10.9989C22 6.72891 20.54 4.64891 17 4.12891",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4.12891C3.46 4.64891 2 6.72891 2 10.9989V14.9989C2 19.9989 4 21.9989 9 21.9989H15C20 21.9989 22 19.9989 22 14.9989V10.9989C22 6.72891 20.54 4.64891 17 4.12891",
    stroke: "#797EDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 2V9L14 7",
    stroke: "#797EDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 9L10 7",
    stroke: "#797EDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.97656 13H6.38656C6.76656 13 7.10656 13.21 7.27656 13.55L8.44656 15.89C8.78656 16.57 9.47656 17 10.2366 17H13.7666C14.5266 17 15.2166 16.57 15.5566 15.89L16.7266 13.55C16.8966 13.21 17.2466 13 17.6166 13H21.9766",
    stroke: "#797EDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetAppIcon);
export default __webpack_public_path__ + "static/media/get_app_icon.7c67a6afe7b5e7204efe160c3813b290.svg";
export { ForwardRef as ReactComponent };